import { render, staticRenderFns } from "./AppNavigation.vue?vue&type=template&id=28b2b264&scoped=true&"
import script from "./AppNavigation.vue?vue&type=script&lang=js&"
export * from "./AppNavigation.vue?vue&type=script&lang=js&"
import style0 from "./AppNavigation.vue?vue&type=style&index=0&id=28b2b264&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b2b264",
  null
  
)

export default component.exports